import React, { useState } from 'react'
import { WeedingPassTable } from './WeedingPassTable'
import { useEffect } from 'react'
import { getAgencyPaymentScheme, getWeedingPass, updateWeedingPassMessage, weedingPassListDetails } from '../../../store/slices/groupFiles/thunks'
import { useDispatch, useSelector } from 'react-redux'
import { AddWeedingPass } from './AddWeedingPass'
import { getCategoriesList } from '../../../store/slices/catalogue/thunks'
import { MyTextInput } from '../../ui/controls/MyTextInput'
import { EditWeedingPass } from "./EditWeedingPass";
import { ModalWeedingPassImage } from "../../ui/controls/ModalWeedingPassImage";

export const WeedingPass = ({ groupFile }) => {
  const { categoriesList } = useSelector((state) => state.catalogue); 
  const dispatch = useDispatch();
  const [addWeedingPass, setAddWeedingPass] = useState(false);
  const [message, setMessage] = useState(groupFile.weedingPassMessage || "");
  const [viewImage, setViewImage] = useState(false);
  const [editWeedingPass2, setEditWeedingPass2] = useState(false);
  const [weedingPassSelected, setWeedingPassSelected] = useState({});
  


  useEffect(() => {
    dispatch(getWeedingPass(groupFile.id));
  }, [])

  useEffect(() => {
    dispatch(getCategoriesList());
  }, [])

  const save = () => {
    const success = () => { };
    dispatch(updateWeedingPassMessage(message, groupFile.id, success));
  }

  const edit2 = (weedingPass) => {
    setEditWeedingPass2(true);
    setWeedingPassSelected(weedingPass);
  }

  const viewImage2 = (weedingPass) => {
    setViewImage(true);
    setWeedingPassSelected(weedingPass);
  }

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ fontSize: 20 }}>Weeding Pass Adicionales</div>

      <div className="col-lg-12 col-md-12 mt-3">
        <div className="row">
          <label>Mensaje a mostrar:</label>
        </div>
        <div className="row">
          <textarea className="form-control" type="text" rows="2" value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </div>
        <div className="row" style={{ justifyContent: "flex-end"}} >
          <button className="btn btn-light" style={{ marginTop: 20, marginBottom: 20, width:100 }} onClick={() => save(true)} >Guardar</button>
        </div>
      </div>


      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button className="btn btn-light btn-icon"
          onClick={() => setAddWeedingPass(true)} >Agregar Weeding Pass</button>
        <button className={`btn text-white btn-primary`}
          onClick={() => dispatch(weedingPassListDetails(groupFile.id))} >Descargar Weeding Pass List</button>
      </div>

      <AddWeedingPass groupFile={groupFile} categories={categoriesList} isOpen={addWeedingPass} setIsOpen={setAddWeedingPass} />
      <WeedingPassTable edit2={edit2} viewImage2={viewImage2} />

      <EditWeedingPass weedingPass={weedingPassSelected} groupFile={groupFile} categories={categoriesList}
              isOpen={editWeedingPass2} setIsOpen={setEditWeedingPass2} />
      <ModalWeedingPassImage code={groupFile.code} id={weedingPassSelected.id} isOpen={viewImage} setIsOpen={setViewImage} />
    </div>
  )
}
